<script>
export default {
  name: 'status-badge.generic',
  props: {
    status: {
      type: String,
      default: 'open'
    }
  }
}
</script>
<template>
  <div class="status-badge">
    <b-card
      no-body
      :bg-variant="`${$t(`web_form_status.${status}.color`)}`"
      class="m-0 status-badge__card"
    >
      <b-card-body
        class="p-1 d-flex align-items-center justify-content-center"
      >
        <i
          :class="[$t(`web_form_status.${status}.icon`), 'text-white']"
          class="mx-1 font-size-16"
        ></i>
        <span class="font-size-10 text-uppercase text-white mx-1">{{
          $t(`web_form_status.${status}.text`)
        }}</span>
      </b-card-body>
    </b-card>
  </div>
</template>

<style lang="scss">
.status-badge {
  display: inline-block;
  width: 7.5rem;
  min-width: 7.5rem;
  max-width: 7.5rem;
  flex: 0 0 7.5rem;
}

.status-badge .status-badge__card,
.status-badge .card {
  width: 100% !important;
}

.status-badge .card-body {
  width: 100%;
  white-space: nowrap;
  justify-content: center !important;
}
</style>
